import * as React from 'react'
import PropTypes from 'prop-types'
import PreviewCompatibleImage from 'src/components/PreviewCompatibleImage'
import NextLink, { LinkType } from 'src/components/NextLink'

import * as style from './style.module.css'

export default function IntroSectionItem({
  image,
  title,
  description,
  cta,
}) {
  return (
    <div className={style.item}>
      {image && (
        <PreviewCompatibleImage
          imageInfo={{
            image,
            alt: title,
            className: style.image,
          }}
        />
      )}
      <h3 className={style.title}>{title}</h3>
      <p>{description}</p>
      <NextLink className={style.button} link={cta} />
    </div>
  )
}

IntroSectionItem.defaultProps = {
  title: 'Item Title Goes Here',
  description: 'Item description goes here',
  cta: {
    text: 'Learn More',
    href: '/',
  },
}

export const IntroSectionItemType = {
  image: PropTypes.any,
  title: PropTypes.string,
  description: PropTypes.string,
  cta: LinkType,
}

IntroSectionItem.propTypes = IntroSectionItemType
